<div class="m-header">
  <div class="m-title">{{ formTitle }}</div>
  <div class="m-actions">
    <button mat-icon-button (click)="maximize()">
      <mat-icon>{{ isMaximized ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
    </button>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="m-content">
  <ng-content></ng-content>
</div>
<div class="m-footer">
  <button *ngIf="showCloseButton" mat-stroked-button color="primary" (click)="close()">{{ 'buttons.cancel' | translate }}</button>
  <ng-content select=".form-buttons"></ng-content>
  <button *ngIf="showSaveButton" [disabled]="disableSaveButton" mat-flat-button color="primary" (click)="save()">{{ 'buttons.save' | translate }}</button>
</div>